module.exports = __webpack_public_path__ + "img/img_faxian_huiyuan@2x.1f6ff33d.png";